module.exports = __webpack_public_path__ + "static/media/cinema-header.e5065504.webp";